import { AfterViewInit, Component, HostListener, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { WindowService } from 'angular-v2-services';
import { switchMap } from 'rxjs';

import { environment } from '../environments/environment';
import { VisitorsAreaService } from './services/visitors-area.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  showCookiesInfo = false;
  private innerHeight!: number;
  private gtmService?: GoogleTagManagerService;

  constructor(
    private windowService: WindowService,
    private injector: Injector,
    protected visitorsAreaService: VisitorsAreaService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerHeight = this.windowService.innerHeight ?? 0;
    this.appHeight();
  }

  ngOnInit(): void {
    this.innerHeight = this.windowService.innerHeight ?? 0;
    this.appHeight();
    if (environment?.gtmId) {
      this.loadGtmService();
      this.gtmService?.addGtmToDom().catch(err => {});
    }
  }

  ngAfterViewInit() {
    this.visitorsAreaService
      .getConfig()
      .pipe(switchMap(config => this.visitorsAreaService.gaVisit(config.companyId, this.getReferralId())))
      .subscribe(() => {
        const gaCookies = localStorage.getItem('GA_COOKIES') === 'true';
        if (!gaCookies && this.route.snapshot.queryParamMap.get('preview') !== 'true') {
          this.showCookiesInfo = true;
        }
      });
  }

  onCookiesAcceptClick(accept?: boolean): void {
    localStorage.setItem('GA_COOKIES', `${accept}`);
    this.showCookiesInfo = false;
  }

  private appHeight(): void {
    const doc = this.windowService.document?.documentElement;
    doc?.style.setProperty('--app-height', `${this.innerHeight}px`);
  }

  private loadGtmService() {
    this.gtmService = this.injector.get(GoogleTagManagerService);
  }

  private getReferralId() {
    switch (this.router.url) {
      case '/no-reservation':
        return 'noReservation';
      default:
        return localStorage.getItem('guestId') as string;
    }
  }
}
